import { render, staticRenderFns } from "./NumericKeyboard.vue?vue&type=template&id=c5b5e2a4&scoped=true&"
import script from "./NumericKeyboard.vue?vue&type=script&lang=js&"
export * from "./NumericKeyboard.vue?vue&type=script&lang=js&"
import style1 from "./NumericKeyboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5e2a4",
  null
  
)

export default component.exports